import { render, staticRenderFns } from "./AddPatientModal.vue?vue&type=template&id=6f546e7f"
import script from "./AddPatientModal.vue?vue&type=script&lang=js"
export * from "./AddPatientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports